import { blackColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const accountsStyle = () => ({
	headerCaption: {
		marginTop: '16px',
		marginBottom: '8px',
	},
	bodyCaption: {
		marginBottom: '6px',
	},
	cardBody: {
		padding: '16px 16px 30px 16px',
		minHeight: '88px',
	},
	noDepartments: {
		marginBottom: 0,
	},
	departmentBadge: {
		marginBottom: 5,
	},
	card: {
		height: 'calc(100% - 40px)',
		boxShadow: `0 8px 8px -6px rgba(${hexToRgb(blackColor)}, 0.5)`,
		marginBottom: '24px',
		cursor: 'pointer',
		transition: 'all .1s ease-in-out',
		'&:hover': {
			marginBottom: '26px',
			marginTop: '14px',
			boxShadow: `0 8px 8px -6px rgba(${hexToRgb(blackColor)}, 0.3)`,
		},
		'&:active': {
			marginBottom: '24px',
			marginTop: '16px',
			boxShadow: `0 8px 8px -6px rgba(${hexToRgb(blackColor)}, 0.6)`,
		},
	},
	cardIconImage: {
		width: '100%',
		height: 'auto',
		objectFit: 'contain',
	},
	reloadSection: {
		marginTop: '100px',
	},
});

export default accountsStyle;
